/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 異動履歴対象項目
 */
export interface IdouRirekiTargetItemInfo { 
    /**
     * 履歴取得対象項目ＴＢＬ
     */
    rirekiGetTargetItemTable?: string;
    /**
     * 履歴取得対象項目ＩＤ
     */
    rirekiGetTargetItemId?: string;
    /**
     * 履歴取得対象項目日本語名
     */
    rirekiGetTargetItemJapaneseName?: string;
    /**
     * 履歴取得対象項目属性
     */
    rirekiGetTargetItemAttribute?: string;
    /**
     * 桁数
     */
    digitNumber?: string;
    /**
     * 値
     */
    value?: string;
}

